import React from 'react';
import { AppShell, ScrollArea, Text, Stack } from '@mantine/core';
import { NavbarSection } from './NavbarSection';

interface AppNavbarProps {
  sectionsWithProgress: any[];
}

export const AppNavbar = React.memo(({ sectionsWithProgress }: AppNavbarProps) => {

  return (
    <>
      <AppShell.Navbar p="md" bg="gray.0">
        <AppShell.Section grow component={ScrollArea}>
          <Stack h="100%" justify="space-between">
            <div>
              {sectionsWithProgress.length === 0 ? (
                <Text size="sm" c="dimmed" ta="center">
                  No sections available
                </Text>
              ) : (
                <>
                  {/* Contracting Section */}
                  <Text size="xs" fw={600} c="dimmed" tt="uppercase" mb="xs">
                    Contracting
                  </Text>
                  {sectionsWithProgress
                    .filter((section) => section.id === 'community-input')
                    .map((section) => (
                      <NavbarSection
                        key={section.id}
                        section={section}
                      />
                    ))}

                  {/* Implementation Section */}
                  <Text size="xs" fw={600} c="dimmed" tt="uppercase" mt="lg" mb="xs">
                    Implementation
                  </Text>
                  {sectionsWithProgress
                    .filter((section) => section.id !== 'community-input')
                    .map((section) => (
                      <NavbarSection
                        key={section.id}
                        section={section}
                      />
                    ))}
                </>
              )}
            </div>
          </Stack>
        </AppShell.Section>
      </AppShell.Navbar>

    </>
  );
});